import { render, staticRenderFns } from "./OpcaoPlanta.vue?vue&type=template&id=483bf11a&scoped=true&"
import script from "./OpcaoPlanta.vue?vue&type=script&lang=js&"
export * from "./OpcaoPlanta.vue?vue&type=script&lang=js&"
import style0 from "./OpcaoPlanta.vue?vue&type=style&index=0&id=483bf11a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bf11a",
  null
  
)

export default component.exports